module.exports = __webpack_public_path__ + "img/History_Line_16px_Icon.acf0f9dc.svg";